__turbopack_context__.v({
  "empty": "SiEgja_empty",
  "manageLink": "SiEgja_manageLink",
  "primaryButton": "SiEgja_primaryButton",
  "subtitle": "SiEgja_subtitle",
  "title": "SiEgja_title",
});
